import styled from '@emotion/styled';

export const ModeToggleText = styled.div`
  position: absolute;
  right: 0;
  padding-bottom: 8px;
  text-transform: uppercase;
  transform: translateY(-100%);
  > button {
    margin-right: -32px;
    margin-bottom: -14px;
  }
`;

export const TextEditorWrapper = styled.div(
  (props: { isShowingError: boolean; isUsingKeyboard: boolean }) => `
  border-radius: 4px;
  border: 0;
  box-shadow: inset 0 0 0 1px var(${
    props.isShowingError ? '--essential-negative' : '--essential-subdued'
  },#878787);
  overflow: hidden;
  outline: 0;
  background: var(--background-base);

  &:hover {
    box-shadow: inset 0 0 0 1px var(${
      props.isShowingError ? '--essential-negative' : '--essential-base'
    });
  }
  &:focus, &:focus-within {
    box-shadow: inset 0 0 0 ${props.isUsingKeyboard ? '3px' : '1.5px'} var(${
    props.isShowingError ? '--essential-negative' : '--essential-base'
  });
  }
  
  .public-DraftEditorPlaceholder-root {
    position: absolute;
    color: var(--text-subdued);
    font-weight: normal;
    font-size: 16px;
    padding: 0;
    pointer-events: none;
  }
  .public-DraftEditor-content {
    min-height: 272px;
  }
`
);

export const Container = styled.div`
  position: relative;
`;
